<div class="page-content">

  <!-- HEADER (uma linha) -->
  <div class="page_header">
    <div class="page_header_text">
      <app-back-button></app-back-button>
      <h1>Escala #{{ escala?.id ?? escalaId }}</h1>
      <span *ngIf="escala" class="header-posto">
        <i class="ri-map-pin-2-line"></i>{{ escala.nomePosto }}
      </span>
    </div>
    <div class="page_header_actions" *ngIf="escala && !loading && podeEditarEscala">
      <button class="btn-web-secondary" (click)="openEdit()">
        <i class="fas fa-pencil-alt"></i> Editar
      </button>
      <button class="btn-web-primary" (click)="openAddEfetivo()">
        <i class="fas fa-user-plus"></i> Adicionar Efectivo
      </button>
    </div>
  </div>

  <!-- SKELETON (apenas no primeiro carregamento) -->
  <ng-container *ngIf="loading">
    <p-skeleton height="120px" styleClass="mb-4"></p-skeleton>
    <p-skeleton height="80px" styleClass="mb-3"></p-skeleton>
    <p-skeleton height="80px" styleClass="mb-3"></p-skeleton>
  </ng-container>

  <ng-container *ngIf="!loading && escala">
    <!-- CARD RESUMO -->
    <div class="escala-hero">
      <div class="hero-left">
        <div class="hero-icon">
          <i class="ri-calendar-event-fill"></i>
        </div>

        <div class="hero-info">
          <div class="hero-tags">
            <span
              class="hero-estado-pill"
              *ngIf="estadoLabel"
              [ngClass]="getEstadoClass()"
            >
              <span class="estado-dot"></span>
              {{ estadoLabel }}
            </span>
            <span class="badge" *ngIf="tipoTurnoLabel" [ngClass]="tipoTurnoClass">
              {{ tipoTurnoLabel }}
            </span>
          </div>

          <div class="hero-info-row hero-criacao" *ngIf="criacaoLabel">
            <i class="ri-history-line hi-icon purple"></i>
            <div class="hi-body">
              <span class="hi-val">{{ criacaoLabel }}</span>
              <span class="hi-lbl">Data de criação</span>
            </div>
          </div>
        </div>
      </div>

      <div class="hero-kpis">
        <div class="hero-kpi">
          <i class="ri-calendar-event-line hk-icon green"></i>
          <div class="hk-body">
            <span class="hk-val">{{ kpiPeriodo }}</span>
            <span class="hk-lbl">Período</span>
          </div>
        </div>

        <div class="hero-kpi-divider"></div>

        <div class="hero-kpi">
          <i class="ri-team-line hk-icon orange"></i>
          <div class="hk-body">
            <span class="hk-val">{{ efectivoCards.length }}</span>
            <span class="hk-lbl">Efectivos</span>
          </div>
        </div>

        <div class="hero-kpi-divider"></div>

        <div class="hero-kpi">
          <i class="ri-hourglass-line hk-icon purple"></i>
          <div class="hk-body">
            <span class="hk-val">{{ kpiDuracao }}</span>
            <span class="hk-lbl">Duração</span>
          </div>
        </div>
      </div>
    </div>

    <!-- TABS -->
    <p-tabs [value]="activeTab" (valueChange)="onTabChange($event)">
      <p-tablist>
        <p-tab value="0">
          <span class="detail-tab-label"><i class="ri-team-line"></i> Efectivos</span>
          <span class="tab-badge">{{ efectivoCards.length }}</span>
        </p-tab>
        <p-tab value="1">
          <span class="detail-tab-label"><i class="ri-history-line"></i> Histórico</span>
        </p-tab>
        <p-tab value="2">
          <span class="detail-tab-label"><hugeicons-icon [icon]="ocorrenciasIcon" [size]="16"></hugeicons-icon> Ocorrências</span>
          <span class="tab-badge">{{ ocorrenciasTotal }}</span>
        </p-tab>
      </p-tablist>

      <p-tabpanels>
        <!-- ── TAB 0: EFECTIVOS ── -->
        <p-tabpanel value="0">
          <div class="tab-panel-content" *ngIf="activeTab === '0'">
            <app-empty-state
              *ngIf="efectivoCards.length === 0"
              icon="ri-team-line"
              title="Sem efectivos escalados"
              message="Adicione efectivos a esta escala para a tornar operacional."
              actionLabel="Adicionar Efectivo"
              (action)="openAddEfetivo()"
            >
            </app-empty-state>

            <div class="efectivos-grid" *ngIf="efectivoCards.length > 0">
              <div class="efectivo-card" *ngFor="let card of efectivoCards; trackBy: trackByCard">
                <!-- Avatar / nome / função / badge -->
                <div class="efcard-header">
                  <div class="efcard-avatar">
                    <img *ngIf="card.foto" [src]="card.foto" [alt]="card.nome" />
                    <span *ngIf="!card.foto">{{ getInitials(card.nome) }}</span>
                  </div>
                  <div class="efcard-info">
                    <span class="efcard-nome">{{ card.nome }}</span>
                    <span class="efcard-funcao" *ngIf="card.funcao">{{ card.funcao }}</span>
                  </div>
                  <span class="presenca-badge" [ngClass]="card.presencaClass">
                    {{ card.presencaLabel }}
                  </span>
                </div>

                <!-- Presença: entrada prevista / entrada real / saída -->
                <div class="efcard-presenca">
                  <div class="presenca-col">
                    <span class="presenca-lbl">Entrada prevista</span>
                    <span class="presenca-val">{{ card.entradaPrevista }}</span>
                  </div>
                  <div class="presenca-col">
                    <span class="presenca-lbl">Entrada real</span>
                    <span
                      class="presenca-val"
                      [class.presenca-pendente]="!card.entradaRegistada"
                      >{{ card.entradaReal }}</span
                    >
                  </div>
                  <div class="presenca-col">
                    <span class="presenca-lbl">Saída</span>
                    <span
                      class="presenca-val"
                      [class.presenca-pendente]="!card.saidaRegistada"
                      >{{ card.saida }}</span
                    >
                  </div>
                </div>

                <!-- Observação / avaliação (após conclusão do turno) -->
                <div class="efcard-obs" *ngIf="card.turnoTerminado && card.observacaoFim">
                  <i class="ri-chat-3-line"></i>
                  <div>
                    <span class="efcard-extra-lbl">Observação</span>
                    <span class="efcard-extra-val">{{ card.observacaoFim }}</span>
                  </div>
                </div>

                <div class="efcard-avaliacao" *ngIf="card.turnoTerminado && card.avaliacaoFim !== null">
                  <span class="efcard-extra-lbl">Avaliação</span>
                  <div class="aval-stars">
                    <i
                      class="ri-star-fill"
                      *ngFor="let s of [1, 2, 3, 4, 5].slice(0, card.avaliacaoFim)"
                    ></i>
                    <i
                      class="ri-star-line"
                      *ngFor="let s of [1, 2, 3, 4, 5].slice(card.avaliacaoFim ?? 0)"
                    ></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </p-tabpanel>

        <!-- ── TAB 1: HISTÓRICO ── -->
        <p-tabpanel value="1">
          <div class="tab-panel-content" *ngIf="activeTab === '1'">
            <p-skeleton *ngIf="loadingHistorico" height="90px" styleClass="mb-3"></p-skeleton>
            <p-skeleton *ngIf="loadingHistorico" height="90px" styleClass="mb-3"></p-skeleton>
            <p-skeleton *ngIf="loadingHistorico" height="90px"></p-skeleton>

            <ng-container *ngIf="!loadingHistorico">
              <app-empty-state
                *ngIf="historicoEventos.length === 0"
                icon="ri-history-line"
                title="Sem histórico registado"
                message="Ainda não existem eventos registados nesta escala."
              >
              </app-empty-state>

              <div class="historico-card" *ngIf="historicoEventos.length > 0">
                <div
                  class="hist-item"
                  *ngFor="let evento of historicoEventos; trackBy: trackByEvento; let last = last"
                >
                  <div class="hist-dot-col">
                    <div class="hist-dot" [ngClass]="'hist-dot-' + evento.cor"></div>
                    <div class="hist-line" *ngIf="!last"></div>
                  </div>
                  <div class="hist-body">
                    <div class="hist-head">
                      <i [class]="evento.icone + ' hist-icon hist-icon-' + evento.cor"></i>
                      <span class="hist-titulo">{{ evento.titulo }}</span>
                      <span class="hist-quando">{{ evento.quandoLabel }}</span>
                    </div>
                    <span class="hist-detalhe" *ngIf="evento.detalhe">{{ evento.detalhe }}</span>
                    <span class="hist-autor" *ngIf="evento.autor">
                      <i class="ri-user-3-line"></i> {{ evento.autor }}
                    </span>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </p-tabpanel>

        <!-- ── TAB 2: OCORRÊNCIAS ── -->
        <p-tabpanel value="2">
          <div class="tab-panel-content" *ngIf="activeTab === '2'">
            <app-escala-historico
              [items]="ocorrencias"
              [loading]="loadingOcorrencias"
              [compact]="true"
              [emptyStateHugeIcon]="ocorrenciasIcon"
              [occurrenceHugeIcon]="ocorrenciasIcon"
              emptyText="Nenhuma ocorrência registada"
            >
            </app-escala-historico>
          </div>
        </p-tabpanel>
      </p-tabpanels>
    </p-tabs>
  </ng-container>

  <!-- DRAWER: ADICIONAR EFECTIVO -->
  <p-drawer
    header="Adicionar Efectivo à Escala"
    [(visible)]="showAddEfetivoDialog"
    position="right"
    [modal]="true"
    [style]="{ width: '480px' }"
    styleClass="efetivo-drawer-dark"
  >
    <div class="dialog-form">
      <div class="form-group">
        <label>Efectivo *</label>
        <p-select
          [(ngModel)]="efetivoParaAdicionar"
          [options]="efetivosDisponiveis"
          optionLabel="nome"
          optionValue="id"
          placeholder="Seleccionar efectivo..."
          [filter]="true"
          filterPlaceholder="Pesquisar..."
          styleClass="w-full"
          appendTo="body"
          [loading]="loadingDrops"
        >
          <ng-template pTemplate="item" let-ef>
            <div style="display: flex; align-items: center; gap: 10px">
              <div class="mini-avatar">{{ getInitials(ef.nome) }}</div>
              <div>
                <div style="font-weight: 500; font-size: 13px">
                  {{ ef.nome }}
                </div>
                <div style="font-size: 11px; color: var(--sp-muted)">
                  BI: {{ ef.numBI }}
                </div>
              </div>
            </div>
          </ng-template>
        </p-select>
      </div>
    </div>

    <ng-template pTemplate="footer">
      <button
        type="button"
        class="btn-web-secondary"
        (click)="showAddEfetivoDialog = false"
      >
        Cancelar
      </button>
      <button
        class="btn-web-primary"
        (click)="confirmarAdicionarEfetivo()"
        [disabled]="addingEfetivo || !efetivoParaAdicionar"
      >
        <i
          [class]="addingEfetivo ? 'fas fa-spinner fa-spin' : 'fas fa-user-plus'"
        ></i>
        {{ addingEfetivo ? "A adicionar..." : "Adicionar" }}
      </button>
    </ng-template>
  </p-drawer>

  <!-- DRAWER: EDITAR ESCALA -->
  <p-drawer
    header="Editar Escala"
    [(visible)]="showEditDialog"
    position="right"
    [modal]="true"
    [style]="{ width: '520px' }"
    styleClass="efetivo-drawer-dark"
  >
    <form *ngIf="editForm" [formGroup]="editForm" class="dialog-form">
      <div class="form-group">
        <label>Turno *</label>
        <div class="turno-grid">
          <button
            type="button"
            class="turno-card"
            *ngFor="let t of turnos"
            [class.active]="editForm.get('turnoId')?.value === t.id"
            (click)="editForm.get('turnoId')?.setValue(t.id)"
          >
            <i class="fas fa-clock"></i>
            <span>{{ t.designacao }}</span>
            <span class="turno-horas" *ngIf="t.horaInicio">
              {{ t.horaInicio?.slice(0, 5) }} – {{ t.horaFim?.slice(0, 5) }}
            </span>
            <i
              class="ri-check-circle-fill turno-check"
              *ngIf="editForm.get('turnoId')?.value === t.id"
            ></i>
          </button>
        </div>
        <small
          class="sp-error"
          *ngIf="
            editForm.get('turnoId')?.invalid && editForm.get('turnoId')?.touched
          "
        >
          Seleccione um turno
        </small>
      </div>

      <div class="form-grid-2">
        <div class="form-group">
          <label>Data de Início *</label>
          <p-datepicker
            formControlName="dataInicio"
            dateFormat="dd/mm/yy"
            [showIcon]="true"
            styleClass="w-full"
            appendTo="body" [autoZIndex]="true" [baseZIndex]="1000010" panelStyleClass="drawer-datepicker-panel"
          >
          </p-datepicker>
          <small
            class="sp-error"
            *ngIf="
              editForm.get('dataInicio')?.invalid &&
              editForm.get('dataInicio')?.touched
            "
          >
            Obrigatório
          </small>
        </div>
        <div class="form-group">
          <label>Data de Fim *</label>
          <p-datepicker
            formControlName="dataTermino"
            dateFormat="dd/mm/yy"
            [showIcon]="true"
            [minDate]="editForm.get('dataInicio')?.value"
            styleClass="w-full"
            appendTo="body" [autoZIndex]="true" [baseZIndex]="1000010" panelStyleClass="drawer-datepicker-panel"
          >
          </p-datepicker>
          <small
            class="sp-error"
            *ngIf="
              editForm.get('dataTermino')?.invalid &&
              editForm.get('dataTermino')?.touched
            "
          >
            Obrigatório
          </small>
        </div>
      </div>
    </form>

    <ng-template pTemplate="footer">
      <button
        type="button"
        class="btn-web-secondary"
        (click)="showEditDialog = false"
      >
        Cancelar
      </button>
      <button class="btn-web-primary" (click)="saveEdit()" [disabled]="savingEdit">
        <i [class]="savingEdit ? 'fas fa-spinner fa-spin' : 'fas fa-save'"></i>
        {{ savingEdit ? "A guardar..." : "Guardar" }}
      </button>
    </ng-template>
  </p-drawer>
</div>
